module.exports = [
  'Cb Major',
  'C Major',
  'C# Major',
  'Db Major',
  'D Major',
  'Eb Major',
  'E Major',
  'F Major',
  'F# Major',
  'Gb Major',
  'G Major',
  'Ab Major',
  'A Major',
  'Bb Major',
  'B Major',
  'C Minor',
  'C# Minor',
  'D Minor',
  'D# Minor',
  'Eb Minor',
  'E Minor',
  'F Minor',
  'F# Minor',
  'G Minor',
  'G# Minor',
  'Ab Minor',
  'A Minor',
  'A# Minor',
  'Bb Minor',
  'B Minor'
];
